// extracted by mini-css-extract-plugin
export default {"cashless_form_bx":"CashlessForm_cashless_form_bx__eI-gm"};